import { Skill } from "@/models";

import * as Fa from "react-icons/fa";
import * as Si from "react-icons/si";
import * as Vsc from "react-icons/vsc";

export const skillsData: Skill[] = [
  {
    title: "HTML5",
    icon: <Fa.FaHtml5 role="presentation" aria-hidden="true" style={{ color: "#DD4B25" }} />,
  },
  {
    title: "CSS3",
    icon: <Fa.FaCss3 role="presentation" aria-hidden="true" style={{ color: "#016AB5" }} />,
  },
  {
    title: "JavaScript",
    icon: <Fa.FaJs role="presentation" aria-hidden="true" style={{ color: "#EAD41C" }} />,
  },
  {
    title: "Sass",
    icon: <Fa.FaSass role="presentation" aria-hidden="true" style={{ color: "#CA689B" }} />,
  },
  {
    title: "React.js",
    icon: <Fa.FaReact role="presentation" aria-hidden="true" style={{ color: "#5CCFEE" }} />,
  },
  {
    title: "TypeScript",
    icon: <Si.SiTypescript role="presentation" aria-hidden="true" style={{ color: "#2E72BC" }} />,
  },
  {
    title: "Spring",
    icon: <Si.SiSpring role="presentation" aria-hidden="true" style={{ color: "#67AA3C" }} />,
  },
  {
    title: "Node.js",
    icon: <Si.SiNodedotjs role="presentation" aria-hidden="true" style={{ color: "#83BA00" }} />,
  },
  {
    title: "MySQL",
    icon: <Si.SiMysql role="presentation" aria-hidden="true" style={{ color: "#005C83" }} />,
  },
  {
    title: "MongoDB",
    icon: <Si.SiMongodb role="presentation" aria-hidden="true" style={{ color: "#64A83D" }} />,
  },
  {
    title: "Redux",
    icon: <Si.SiRedux role="presentation" aria-hidden="true" style={{ color: "#7046B2" }} />,
  },
  {
    title: "Jest",
    icon: <Si.SiJest role="presentation" aria-hidden="true" style={{ color: "#BE3B16" }} />,
  },
  {
    title: "Testing L.",
    icon: <Si.SiTestinglibrary role="presentation" aria-hidden="true" style={{ color: "#E81C27" }} />,
  },
  {
    title: "Docker",
    icon: <Si.SiDocker role="presentation" aria-hidden="true" style={{ color: "#1197D0" }} />,
  },
  {
    title: "Git",
    icon: <Si.SiGit role="presentation" aria-hidden="true" style={{ color: "#E44D30" }} />,
  },
  {
    title: "Ant Design",
    icon: <Si.SiAntdesign role="presentation" aria-hidden="true" style={{ color: "#0F76FF" }} />,
  },
  {
    title: "Bootstrap",
    icon: <Si.SiBootstrap role="presentation" aria-hidden="true" style={{ color: "#6C12EA" }} />,
  },
  {
    title: "Python",
    icon: <Si.SiPython role="presentation" aria-hidden="true" style={{ color: "#F7D54D" }} />,
  },
  {
    title: "Yarn",
    icon: <Si.SiYarn role="presentation" aria-hidden="true" style={{ color: "#3392BD" }} />,
  },
  {
    title: "Npm",
    icon: <Si.SiNpm role="presentation" aria-hidden="true" style={{ color: "#CA3D3D" }} />,
  },
  {
    title: "PostgreSQL",
    icon: <Si.SiPostgresql role="presentation" aria-hidden="true" style={{ color: "#386B93" }} />,
  },
  {
    title: "Azure",
    icon: <Vsc.VscAzureDevops role="presentation" aria-hidden="true" style={{ color: "#097CD6" }} />,
  },
  {
    title: "Postman",
    icon: <Si.SiPostman role="presentation" aria-hidden="true" style={{ color: "#FF713E" }} />,
  },
  {
    title: "Powershell",
    icon: <Vsc.VscTerminalPowershell role="presentation" aria-hidden="true" style={{ color: "#2E81CB" }} />,
  },
  {
    title: "NextJS",
    icon: <Si.SiNextdotjs role="presentation" aria-hidden="true" style={{ color: "#000000" }} />,
  },
  {
    title: "NodeJS",
    icon: <Si.SiNodedotjs role="presentation" aria-hidden="true" style={{ color: "#83BA00" }} />,
  },
];
